import angular from 'angular';
import { STATES } from '../../constants';
import { IS_PRODUCTION } from '../../environment';
import { actions } from '../../state';

export const ErrorHandlerModule = angular
  .module('app.error-handler', [])
  .run(ErrorHandlerRun);

function ErrorHandlerRun($rootScope, $exceptionHandler, updStore) {
  'ngInject';
  const { dispatch } = updStore;

  $rootScope.$on('$stateChangeError', onError);

  function onError(event, toState, toParams, fromState, fromParams, error) {
    if (!IS_PRODUCTION) {
      console.error('[stateChangeError]');
      console.error(`   State: ${toState.name}`);
      console.error('   Error', error);
    }

    // Show the error page unless the error has been handled.
    if (!event.defaultPrevented && !error.handled) {
      dispatch(
        actions.router.stateGo(STATES.ERROR, null, {
          inherit: true,
        })
      );

      let exception;
      let cause = {
        state: {
          toState,
          toParams,
          fromState,
          fromParams,
        },
      };

      if (error instanceof Error) {
        exception = error;
      } else if (angular.isObject(error)) {
        // Assume error is a $http rejection.
        exception = new Error(
          `${(error.data && error.data.error) || error.statusText}`
        );
        cause.error = error;
      } else {
        exception = new Error(error);
      }

      $exceptionHandler(exception, cause);
    }
  }
}
